import React , { useState , useRef , useEffect }from 'react'

import { ApiCallPost } from '../../ApiCall/ApiCall'


import { useNavigate ,  useLocation } from "react-router-dom";

export default function Campain() {

    
    const [name,setName] = useState('')
    const [message,setMessage] = useState('')
    const [lastcustomer,setLastcustomer] = useState(0)
    const [bucles,setBucles] = useState(1) 
    const [isActive,setIsActive] = useState(1) 
    const [dTimeStamp,setDTimeStamp] = useState(new Date().getTime() ) // Hora universal

    const [dataIni,setDateIni] = useState( null )
    const [dataFin,setDateFin] = useState( null )

    const nameRef = useRef(null)
    const messageRef = useRef(null)
    const buclesRef = useRef(null)


    const location = useLocation() ;
    const navigate = useNavigate() ;


    useEffect( () => {

        if( location.state === null ){
            console.log( "location.state = null" )
            navigate( "/" )
        }

    } , [] )
  


    function onBuclesChange(e){
        setBucles( e.target.value )
    }


    function setDesde(e){

        console.log( "DateIni = " + e.target.value )

        setDateIni( e.target.value )
    }

    function setHasta(e){

        console.log( "DateEnd = " + e.target.value )

        setDateFin( e.target.value )
    }
    
    




    function onSubmit(e){

        e.preventDefault() ;

        console.log('hola')

        console.log( "name = " + nameRef.current.value )
        console.log( "message = " + messageRef.current.value )
        console.log( "bucles = " + buclesRef.current.value )

        console.log( "dTimeStamp = " + new Date() ) ;

        //return ; 


        ApiCallPost('campania', {
            name : nameRef.current.value,
            message : messageRef.current.value,
            desde : dataIni,
            hasta : dataFin,
            lastcustomer : 0,
            bucles : buclesRef.current.value,
            isActive : 1,
            dTimeStamp : new Date()
        }).then( (response) => {
            console.log( response )

            alert( response.mensaje ) ; // Pintamos la respuesta del mensaje

        } ).catch( (error) => {
            console.log( error )
        } )
    
    }


  return (
    
    <div className='d-flex flex-column  justify-content-center box-1 backemployer-2 centersearch' >

        <div className='d-flex flex-column justify-content-center box-1 backemployer-2 mb-5 form-2 w-75'  id="page1" style={{margin : 'auto'}}>

            
        
            

            <div className='row'>
                <div className='col-sm-4'>

                    

                </div>
                <div className='col-sm-4'>
                    <h5>Administrador de campañas SMS</h5>
                </div>
            </div> 

            <form className='pt-1' onSubmit={onSubmit} style={{width:'100%'}}  >

                <div className='row'>
                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="nombre">Nombre Campaña</label>
                                <input ref={nameRef} type="text" className="form-group p-lg-2" id="nombre"  
                                placeholder="Nombre"   
                                />
                                
                            </div>
                        </div>
                </div>




                <div className='row'>
                        <div className="form-group"  >
                                    <label className="m-0" htmlFor="mensaje">Mensaje</label>
                                    <textarea ref={messageRef} type="textarea" className="form-control" id="mensaje"  
                                    placeholder="Mensaje"  maxLength={120} size= {100} rows={2}
                                    />
                                    
                        </div>                
                </div>


                <div className='row'>

                        <div className='col-3'>
                            <label className="form-label m-0" htmlFor="desde">Desde</label>
                            <input type="date" className="form-control" id="desde"  onChange={setDesde} />
                        </div>


                        <div className='col-3'>
                            <label className="form-label m-0" htmlFor="hasta">Hasta</label>
                            <input type="date" className="form-control" id="hasta"  onChange={setHasta} />
                        </div>


                        <div className='col-sm-2'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label  className="form-label m-0" htmlFor="repeticiones">Repeticiones</label>
                                <input ref = {buclesRef} type="number" className="form-group p-lg-2 pt-5" 
                                    id="repeticiones" value={bucles} onChange={onBuclesChange}  
                                
                                />
                                
                            </div>
                        </div>
                </div>

                <div className='col-sm-1'>
                        <button type="submit"  className="btn btn-primary mt-3 button-3"  >Aceptar</button> 
                </div>



            </form>

        </div>    
    </div>
  )
}
